(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["txn-community"] && !Shopify.designMode) return;
  try {
    
function initSqueeze(root){if(root.dataset.ready)return;root.dataset.ready='true';const filters=root.querySelector('.sq-filters');const cards=[...root.querySelectorAll('.sq-card')];filters.hidden=false;filters.addEventListener('click',event=>{const button=event.target.closest('[data-filter]');if(!button)return;filters.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;cards.forEach(card=>{const show=button.dataset.filter==='all'||card.dataset.tags.split(' ').includes(button.dataset.filter);card.hidden=!show;if(show)count++;});root.querySelector('[data-count]').textContent=count;});}
document.querySelectorAll('.sq-community').forEach(initSqueeze);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.sq-community').forEach(initSqueeze));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["txn-lifestyle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('txn-event-gallery')) {
customElements.define('txn-event-gallery', class extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready = true;
const track = this.querySelector('.tl-track');
const slides = [...track.children];
const controls = this.querySelector('.tl-gallery-controls');
const previous = this.querySelector('[data-previous]');
const next = this.querySelector('[data-next]');
let current = 0;
const update = () => {
current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
this.querySelector('[data-count]').textContent = String(current + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
previous.disabled = current === 0;
next.disabled = current === slides.length - 1;
slides.forEach((slide, index) => {
slide.inert = index !== current;
if (index !== current) slide.querySelectorAll('video').forEach(video => video.pause());
});
};
const move = offset => track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, current + offset)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
previous.addEventListener('click', () => move(-1));
next.addEventListener('click', () => move(1));
track.addEventListener('keydown', event => {
if (event.target !== track) return;
if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
event.preventDefault();
move(event.key === 'ArrowRight' ? 1 : -1);
}
});
let frame;
track.addEventListener('scroll', () => {
cancelAnimationFrame(frame);
frame = requestAnimationFrame(update);
}, {passive:true});
controls.hidden = slides.length < 2;
update();
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["txn-pocket-run"] && !Shopify.designMode) return;
  try {
    

(()=>{const root=document.getElementById('txn-pocket-run');if(!root||root.dataset.ready)return;root.dataset.ready='1';const $=s=>root.querySelector(s),dialog=$('.pr-dialog'),field=$('.pr-field'),track=$('.pr-track'),cup=$('.pr-cup'),overlay=$('.pr-overlay'),start=$('.pr-start'),result=$('.pr-result'),help=$('.pr-help'),status=$('.pr-status'),pause=$('.pr-pause');const originalHelp=help.textContent;let state='idle',score=0,remaining=42,items=[],last=0,spawn=0,raf=0,x=150,keys=new Set(),colors=new Set(),best=0,returnFocus=null,level=0,lastDrop=null;const storage={get(k){try{return sessionStorage.getItem(k)}catch{return null}},set(k,v){try{sessionStorage.setItem(k,v)}catch{}}};try{best=Number(localStorage.getItem('txn-pocket-best'))||0}catch{}$('.pr-best span').textContent=best;const names=['fire','gut','green'].map(n=>$('.pr-name-'+n).textContent),palette=['#d95724','#b8901a','#527344'];function place(){x=Math.max(0,Math.min(field.clientWidth-64,x));cup.style.transform=`translateX(${x}px)`}function open(){$('.pr-account').hidden=storage.get('txn-pocket-reward')!=='1';returnFocus=document.activeElement;storage.set('txn-pocket-seen','1');if(!dialog.open)dialog.showModal();x=(field.clientWidth-64)/2;place();start.focus()}function stop(){cancelAnimationFrame(raf);keys.clear()}function close(){stop();state='idle';dialog.close();returnFocus?.focus()}function update(){ $('#pr-score').textContent=score;$('#pr-time').textContent=Math.ceil(remaining);$('.pr-progress').value=Math.min(score,400);const next=score>=280?2:score>=140?1:0;if(next!==level){level=next;$('.pr-level').textContent=[root.dataset.levelOne,root.dataset.levelTwo,root.dataset.levelThree][level];status.textContent=$('.pr-level').textContent}root.querySelectorAll('[data-blend]').forEach(el=>el.dataset.caught=String(colors.has(Number(el.dataset.blend))))}function finish(){stop();if(score>=400)storage.set('txn-pocket-reward','1');state='done';overlay.hidden=false;pause.hidden=true;const won=score>=400;result.textContent=won?root.dataset.win:root.dataset.lose;help.textContent=won?$('.pr-reward-text').textContent:`${score} / 400. `+originalHelp;start.textContent=root.dataset.again;status.textContent=result.textContent;$('.pr-account').hidden=storage.get('txn-pocket-reward')!=='1';best=Math.max(best,score);$('.pr-best span').textContent=best;try{localStorage.setItem('txn-pocket-best',best)}catch{}start.focus()}function tick(now){if(state!=='playing')return;const dt=Math.min((now-last)/1000,.05);last=now;remaining=Math.max(0,remaining-dt);if(keys.has('ArrowLeft'))x-=360*dt;if(keys.has('ArrowRight'))x+=360*dt;place();spawn-=dt;if(spawn<=0){spawn=[.72,.64,.56][level];const type=Math.floor(Math.random()*3),el=document.createElement('div');el.className='pr-packet';el.textContent=names[type];el.style.background=palette[type];track.append(el);const max=field.clientWidth-43;const drop=lastDrop===null?Math.random()*max:Math.max(0,Math.min(max,lastDrop+(Math.random()-.5)*Math.min(230,max)));lastDrop=drop;items.push({el,type,x:drop,y:-60,speed:[90,105,120][level],angle:Math.random()*14-7})}const cupTop=cup.offsetTop,cupWidth=cup.offsetWidth;items=items.filter(o=>{const prev=o.y+o.el.offsetHeight;o.y+=o.speed*dt;o.el.style.transform=`translate(${o.x}px,${o.y}px) rotate(${o.angle}deg)`;if(o.y<=cupTop+12&&Math.max(prev,o.y+o.el.offsetHeight)>=cupTop-3&&o.x+o.el.offsetWidth>=x-3&&o.x<=x+cupWidth+3){score+=10;colors.add(o.type);if(colors.size===3){score+=20;colors.clear();status.textContent=root.dataset.bonus}o.el.remove();return false}if(o.y>field.clientHeight){o.el.remove();return false}return true});update();if(remaining<=0){finish();return}raf=requestAnimationFrame(tick)}function begin(){stop();state='playing';score=0;remaining=42;spawn=0;items=[];colors.clear();level=0;lastDrop=null;$('.pr-level').textContent=root.dataset.levelOne;track.replaceChildren();overlay.hidden=true;$('.pr-account').hidden=true;pause.hidden=false;status.textContent='';update();x=(field.clientWidth-64)/2;place();field.focus();last=performance.now();raf=requestAnimationFrame(tick)}function suspend(){if(state!=='playing')return;stop();state='paused';overlay.hidden=false;result.textContent=root.dataset.pause;help.textContent=originalHelp;start.textContent=$('.pr-resume-text').textContent;pause.hidden=true}start.addEventListener('click',()=>{if(state==='paused'){state='playing';overlay.hidden=true;pause.hidden=false;field.focus();last=performance.now();raf=requestAnimationFrame(tick)}else begin()});$('.pr-launch').addEventListener('click',()=>{if(state==='idle'){result.textContent=$('header>p:last-child').textContent;help.textContent=originalHelp;start.textContent=$('.pr-start-label').textContent;overlay.hidden=false;pause.hidden=true}open()});$('.pr-close').addEventListener('click',close);dialog.addEventListener('cancel',e=>{e.preventDefault();close()});dialog.addEventListener('close',stop);pause.addEventListener('click',suspend);document.addEventListener('visibilitychange',()=>{if(document.hidden)suspend()});window.addEventListener('blur',suspend);field.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();keys.add(e.key)}});field.addEventListener('keyup',e=>keys.delete(e.key));field.addEventListener('pointermove',e=>{if(state!=='playing')return;if(e.pointerType==='touch'&&!field.hasPointerCapture(e.pointerId))return;x=e.clientX-field.getBoundingClientRect().left-32;place()});field.addEventListener('pointerdown',e=>{if(state!=='playing')return;field.setPointerCapture(e.pointerId);x=e.clientX-field.getBoundingClientRect().left-32;place()});if(new URLSearchParams(location.search).get('pocket_run')==='1'||$('.pr-signup [data-signup-success]')||$('.pr-signup [data-signup-error]')){open();$('.pr-signup').open=true}$('.pr-signup form').addEventListener('submit',()=>storage.set('txn-pocket-signup','1'));if(storage.get('txn-pocket-signup')==='1'&&location.hash==='#PocketRunEmail'){open();$('.pr-signup').open=true;storage.set('txn-pocket-signup','0')}})();

  } catch(e) { console.error(e); }
})();
})();
